import React, { SyntheticEvent, useState } from "react";
import { useTheme } from "@mui/material/styles";

function useChartNewsSelector() {
  const theme = useTheme();

  const role = JSON.parse(sessionStorage.getItem("role") || JSON.stringify(""));

  const isAdmin =
    role === "Admin" || role === "Inside Sales" || role === "Outside Sales";

  const [value, setValue] = useState(0);

  const handleChange = (event: SyntheticEvent, newValue: number) =>
    setValue(newValue);

  return {
    handleChange,
    value,
    isAdmin,
    theme,
  };
}

export default useChartNewsSelector;
